module.exports = __webpack_public_path__ + "static/media/10.86eb2324.svg";